var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 73,
    viewBox: "0 0 43 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4144 70.9913C11.5112 68.7378 11.4778 65.0388 15.3692 62.7772C19.1664 60.5708 25.3626 60.5708 29.1862 62.7772C33.0483 65.0083 33.1569 68.7092 29.2303 70.9913C25.4328 73.1974 19.2327 73.1961 15.4144 70.9913ZM15.5525 63.0941C11.9185 65.2052 11.9279 68.5545 15.5977 70.6738C19.3159 72.8204 25.349 72.8226 29.0461 70.6738C32.6869 68.5562 32.6648 65.2091 29.0019 63.0941C25.2885 60.9517 19.2619 60.9404 15.5525 63.0941Z",
    fill: "#4C77FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4605 66.886C28.4661 64.9099 25.7048 63.3001 22.2931 63.2906C18.8814 63.281 16.1113 64.8753 16.1057 66.8514C16.1002 68.8276 18.8614 70.4373 22.2731 70.4469C25.6848 70.4564 28.455 68.8622 28.4605 66.886Z",
    fill: "#4C77FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8651 20.6391C34.895 27.2523 30.2477 35.2659 24.4983 38.6026C21.6384 40.2409 19.0167 40.4196 17.1402 39.3176L11.0928 35.8025C12.9696 36.9048 15.591 36.7557 18.4509 35.0875C24.2006 31.7512 28.8476 23.7376 28.8476 17.124C28.8177 13.8472 27.6559 11.5534 25.809 10.4809L31.8564 13.996C33.7033 15.0681 34.8651 17.3623 34.8651 20.6391Z",
    fill: "#DE4351"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1653 1.21435L37.2091 4.72652C33.94 2.82663 29.4139 3.08921 24.4169 5.97447L18.373 2.4623C23.3701 -0.422959 27.8962 -0.68554 31.1653 1.21435Z",
    fill: "#CE3E50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5945 69.0746L18.5507 65.5624C17.6498 64.5293 0.532271 44.8993 0.500097 33.4811C0.467923 22.0944 8.46233 8.18421 18.3719 2.46277L24.4158 5.97493C14.5062 11.6964 6.51173 25.6063 6.5439 36.9933C6.5764 48.4114 23.6936 68.0415 24.5945 69.0746Z",
    fill: "#DE4351"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.423 5.96384C14.5072 11.7035 6.5206 25.6003 6.54498 36.9815C6.56935 48.4117 23.6901 68.0479 24.5939 69.0739C25.4977 66.9979 42.496 27.6764 42.4473 16.2462C42.4229 4.86504 34.3631 0.248892 24.423 5.96384ZM24.4961 38.5934C18.7812 41.8904 14.1163 39.2285 14.0919 32.6341C14.0675 26.0641 18.7077 18.0288 24.4473 14.7074C30.1867 11.4103 34.8516 14.0723 34.876 20.6423C34.9003 27.2367 30.2601 35.2717 24.4961 38.5934Z",
    fill: "#F1565D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54433 36.993C6.33016 27.1481 11.6353 14.3913 21.4854 7.27663C24.5777 5.05695 28.2874 3.41737 32.1369 3.51162C28.3047 3.65884 24.7564 5.40436 21.7223 7.60519C13.6177 13.6844 7.01686 25.4289 6.54433 36.993Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8724 20.5939C35.2744 27.2081 30.4535 35.5867 24.4932 38.6029C29.9741 34.899 34.4681 26.9342 34.8724 20.5939Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.254954a6cb08633b045c1a3f9fc5a31d.svg";
export { ForwardRef as ReactComponent };